var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pre-paid"},[_vm._v(" 预付款活动账单，不参与付款 ")])}
var staticRenderFns = []

export { render, staticRenderFns }